import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type RegistrationRequestState = CommonTableState;

const initialState: RegistrationRequestState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            modified: false,
            modifier: false,
        },
        columnOrder: [
            "companyIdNumber",
            "user.person.id",
            "user.person.email",
            "status",
            "created",
            "user.person.phone",
            "partnerCode",
            "software",
            "softwareName",
            "modified",
            "modifier",
            "mrt-row-actions",
            "newsletter",
        ],
        density: "compact",
    },
};

export const registrationRequestSlice = createSlice({
    name: "registrationRequest",
    initialState: initialState,
    reducers: {
        updateRegistrationRequestTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateRegistrationRequestTableState } = registrationRequestSlice.actions;

export default registrationRequestSlice.reducer;
